<template>
  <div class="row home-center" style="background-color:white;">
    <div class="col-12 bg-white">
      <CenterViewPreview v-if="isShowPreviewView" />
      <CenterViewEdit v-if="isShowEditView" />
      <CenterViewUpload v-if="isShowUploadView" />
      <CenterViewOrderHistory v-if="isShowOrderHistoryView" />
      <CenterViewShipping v-if="isShowShippingView" />
      <CenterViewOption v-if="isShowOptionView" />
      <CenterViewInfo v-if="isShowInfoView" />
      <CenterViewDraft v-if="isShowDraftView" />
      <CenterViewSampleUpload v-if="isShowSampleUploadView" />
      <CenterViewSamplePreview v-if="isShowSamplePreviewView" />
      <CenterViewEventManagement v-if="isShowEventManagementView" />
      <CenterViewEventCreate v-if="isShowEventCreateView" />
      <CenterViewEventCreateDesign v-if="isShowEventCreateDesignView" />
      <CenterViewEventEdit v-if="isShowEventEditView" />
      <CenterViewEventTicketIssue v-if="isShowEventTicketIssueView" />
      <CenterViewTicketOrderConfirm v-if="isShowTicketOrderConfirmView" />
      <CenterViewEventDesignUpload v-if="isShowEventDesignUploadView" />
      <CenterViewEventTicketIssueHistory v-if="isShowEventTicketIssueHistoryView" />
      <CenterViewEventTicketIssueDetail v-if="isShowEventTicketIssueDetailView" />
      <CenterViewEventList v-if="isShowEventListView" />
      <CenterViewBehalfCreate v-if="isShowBehalfCreateView" />
      <CenterViewBehalfCreateComplate v-if="isShowBehalfCreateComplateView" />
      <CenterViewCommonPreview v-if="isShowCommonPreviewView" />
      <CenterViewFirstTimeFreeTop v-if="isShowFirstTimeFreeTopView" />
      <CenterViewFirstTimeFreeSurvey v-if="isShowFirstTimeFreeSurveyView" />
      <CenterViewFirstTimeFreeSurveyComplete v-if="isShowFirstTimeFreeSurveyCompleteView" />
      <CenterViewTemplate v-if="isShowTemplateView" />

    </div>
  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";
import CenterViewPreview from "@/components/acyrpro/CenterViewPreview_Ap.vue";
import CenterViewEdit from "@/components/acyrpro/CenterViewEdit_Ap.vue";
import CenterViewUpload from "@/components/acyrpro/CenterViewUpload_Ap.vue";
import CenterViewOrderHistory from "@/components/acyrpro/orderhistory/CenterViewOrderHistory_Ap.vue";
import CenterViewShipping from "@/components/acyrpro/shipping/CenterViewShipping_Ap.vue";
import CenterViewOption from "@/components/acyrpro/CenterViewOption_Ap.vue";
import CenterViewInfo from "@/components/acyrpro/CenterViewInfo_Ap.vue";
import CenterViewDraft from "@/components/acyrpro/CenterViewDraft_Ap.vue";
import CenterViewSampleUpload from "@/components/acyrpro/CenterViewSampleUpload_Ap.vue";
import CenterViewSamplePreview from "@/components/acyrpro/CenterViewSamplePreview_Ap.vue";
import CenterViewEventManagement from "@/components/acyrpro/ticket/CenterViewEventManagement_Ap.vue";
import CenterViewEventCreate from "@/components/acyrpro/ticket/CenterViewEventCreate_Ap.vue";
import CenterViewEventCreateDesign from "@/components/acyrpro/ticket/CenterViewEventCreateDesign_Ap.vue";
import CenterViewEventEdit from "@/components/acyrpro/ticket/CenterViewEventEdit_Ap.vue";
import CenterViewEventTicketIssue from "@/components/acyrpro/ticket/CenterViewEventTicketIssue_Ap.vue";
import CenterViewTicketOrderConfirm from "@/components/acyrpro/ticket/CenterViewTicketOrderConfirm_Ap.vue";
import CenterViewEventDesignUpload from "@/components/acyrpro/ticket/CenterViewEventDesignUpload_Ap.vue";
import CenterViewEventTicketIssueHistory from "@/components/acyrpro/ticket/CenterViewEventTicketIssueHistory_Ap.vue";
import CenterViewEventTicketIssueDetail from "@/components/acyrpro/ticket/CenterViewEventTicketIssueDetail_Ap.vue";
import CenterViewEventList from "@/components/acyrpro/ticket/CenterViewEventList_Ap.vue";
import CenterViewBehalfCreate from "@/components/acyrpro/CenterViewBehalfCreate_Ap.vue";
import CenterViewBehalfCreateComplate from "@/components/acyrpro/CenterViewBehalfCreateComplate_Ap.vue";
import CenterViewCommonPreview from "@/components/acyrpro/CommonView/CenterViewCommonPreview_Ap.vue";
import CenterViewFirstTimeFreeTop from "@/components/acyrpro/FirstTimeFree/CenterViewFirstTimeFreeTop_Ap.vue";
import CenterViewFirstTimeFreeSurvey from "@/components/acyrpro/FirstTimeFree/CenterViewFirstTimeFreeSurvey_Ap.vue";
import CenterViewFirstTimeFreeSurveyComplete from "@/components/acyrpro/FirstTimeFree/CenterViewFirstTimeFreeSurveyComplete_Ap.vue";
import CenterViewTemplate from "@/components/acyrpro/CenterViewTemplate_Ap.vue";


export default {
  name: "Center_Ap",
  props: {},
  data: function () {
    return {

    };
  },
  computed: {
    isShowPreviewView(){
      return this.$store.state.centerViewState == CenterViewState.Preview;
    },
    isShowEditView(){
      return this.$store.state.centerViewState == CenterViewState.Edit;
    },
    isShowUploadView(){
      return this.$store.state.centerViewState == CenterViewState.Upload;
    },
    isShowOrderHistoryView(){
      return this.$store.state.centerViewState == CenterViewState.OrderHistory;
    },
    isShowShippingView(){
      return this.$store.state.centerViewState == CenterViewState.Shipping;
    },
    isShowOptionView(){
      return this.$store.state.centerViewState == CenterViewState.Option;
    },
    isShowInfoView(){
      return this.$store.state.centerViewState == CenterViewState.Info;
    },
    isShowDraftView(){
      return this.$store.state.centerViewState == CenterViewState.Draft;
    },
    isShowSampleUploadView(){
      return this.$store.state.centerViewState == CenterViewState.SampleUpload;
    },
    isShowSamplePreviewView(){
      return this.$store.state.centerViewState == CenterViewState.SamplePreview;
    },
    isShowEventManagementView(){
      return this.$store.state.centerViewState == CenterViewState.EventManagement;
    },
    isShowEventCreateView(){
      return this.$store.state.centerViewState == CenterViewState.EventCreate;
    },
    isShowEventCreateDesignView(){
      return this.$store.state.centerViewState == CenterViewState.EventCreateDesign;
    },
    isShowEventEditView(){
      return this.$store.state.centerViewState == CenterViewState.EventEdit;
    },
    isShowEventTicketIssueView(){
      return this.$store.state.centerViewState == CenterViewState.EventTicketIssue;
    },
    isShowTicketOrderConfirmView(){
      return this.$store.state.centerViewState == CenterViewState.TicketOrderConfirm;
    },
    isShowEventDesignUploadView(){
      return this.$store.state.centerViewState == CenterViewState.EventDesignUpload;
    },
    isShowEventTicketIssueHistoryView(){
      return this.$store.state.centerViewState == CenterViewState.TicketIssueHistory;
    },
    isShowEventTicketIssueDetailView(){
      return this.$store.state.centerViewState == CenterViewState.TicketIssueDetail;
    },
    isShowEventListView(){
      return this.$store.state.centerViewState == CenterViewState.EventList;
    },
    isShowBehalfCreateView(){
      return this.$store.state.centerViewState == CenterViewState.BehalfCreate;
    },
    isShowBehalfCreateComplateView(){
      return this.$store.state.centerViewState == CenterViewState.BehalfCreateComplate;
    },
    isShowCommonPreviewView(){
      return this.$store.state.centerViewState == CenterViewState.CommonPreview;
    },
    isShowFirstTimeFreeTopView(){
      return this.$store.state.centerViewState == CenterViewState.FirstTimeFreeTop;
    },
    isShowFirstTimeFreeSurveyView(){
      return this.$store.state.centerViewState == CenterViewState.FirstTimeFreeSurvey;
    },
    isShowFirstTimeFreeSurveyCompleteView(){
      return this.$store.state.centerViewState == CenterViewState.FirstTimeFreeSurveyComplete;
    },
    isShowTemplateView(){
      return this.$store.state.centerViewState == CenterViewState.Template;
    },
  },
  created: function () {},
  components: {
    CenterViewPreview,
    CenterViewEdit,
    CenterViewUpload,
    CenterViewOrderHistory,
    CenterViewShipping,
    CenterViewOption,
    CenterViewInfo,
    CenterViewDraft,
    CenterViewSampleUpload,
    CenterViewSamplePreview,
    CenterViewEventManagement,
    CenterViewEventCreate,
    CenterViewEventCreateDesign,
    CenterViewEventEdit,
    CenterViewEventTicketIssue,
    CenterViewTicketOrderConfirm,
    CenterViewEventDesignUpload,
    CenterViewEventTicketIssueHistory,
    CenterViewEventTicketIssueDetail,
    CenterViewEventList,
    CenterViewBehalfCreate,
    CenterViewBehalfCreateComplate,
    CenterViewCommonPreview,
    CenterViewFirstTimeFreeTop,
    CenterViewFirstTimeFreeSurvey,
    CenterViewFirstTimeFreeSurveyComplete,
    CenterViewTemplate,
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.textcolor{
  color:#6C6B6B
}
.home-center{
  height: calc(100vh - #{$header-height});

}

</style>
